
import { defineComponent, computed, ref } from 'vue';
import { useStore } from '@/store';
import { Truck } from '@/types/app';
import { alphabetize, lowerCaseIncludes, useModalState } from '@/utils';
import TruckAddEditFormModal from '@/components/modal/TruckAddEditFormModal.vue';
import TruckDeleteFormModal from '@/components/modal/TruckDeleteFormModal.vue';
import TrucksTable from '@/components/tables/TrucksTable.vue';
import ButtonInput from '@/components/form-controls/base/ButtonInput.vue';
import TextInput from '@/components/form-controls/base/TextInput.vue';
import MaterialIconButton from '@/components/form-controls/MaterialIconButton.vue';
import CheckboxInput from '@/components/form-controls/base/CheckboxInput.vue';

export default defineComponent({
  name: 'TrucksManager',
  components: {
    TruckAddEditFormModal,
    TruckDeleteFormModal,
    TrucksTable,
    ButtonInput,
    TextInput,
    MaterialIconButton,
    CheckboxInput
  },
  props: {},
  setup() {
    const store = useStore();
    const searchValue = ref('');
    const trucks = computed(() => store.getters.trucks.get);
    const filteredTrucks = computed(() =>
      trucks.value.filter(
        truck =>
          lowerCaseIncludes(truck.name, searchValue.value) ||
          lowerCaseIncludes(truck.runRate.toString(), searchValue.value) ||
          lowerCaseIncludes(truck.unloadLoadTime.toString(), searchValue.value) ||
          lowerCaseIncludes(truck.capacity.toString(), searchValue.value) ||
          lowerCaseIncludes(truck.enabled.toString(), searchValue.value)
      )
    );

    const sortedTrucks = computed(() => alphabetize(filteredTrucks.value, 'name'));

    const [selectedAddEditTruck, isAddEditModalOpen, openAddEditModal] = useModalState<Truck>();
    const [selectedDeleteTruck, isDeleteModalOpen, openDeleteModal] = useModalState<Truck>();

    const handleTruckUpdate = async (truck: Truck) => {
      await store.dispatch.trucks.update(truck);
    };

    return {
      searchValue,
      sortedTrucks,
      selectedAddEditTruck,
      isAddEditModalOpen,
      openAddEditModal,
      selectedDeleteTruck,
      isDeleteModalOpen,
      openDeleteModal,
      handleTruckUpdate
    };
  }
});
